"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadErrorMessage = exports.CommonControlsHyperlink = exports.UploadViewer = exports.RichTextViewer = exports.LayoutControlsPanel = exports.CommonControlsText = exports.CommonControlsSectionHeader = exports.LayoutControlsGridCol = exports.LayoutControlsGridLayout = exports.ApplicationWorkflowAdditionalAttachments = void 0;
var React = require("react");
var csod = require("player-core");
var ViewSL_1 = require("./ViewSL");
var GridLayout_1 = require("player-layout-controls/controls/GridLayout");
Object.defineProperty(exports, "LayoutControlsGridLayout", { enumerable: true, get: function () { return GridLayout_1.GridLayout; } });
var GridCol_1 = require("player-layout-controls/controls/GridCol");
Object.defineProperty(exports, "LayoutControlsGridCol", { enumerable: true, get: function () { return GridCol_1.GridCol; } });
var SectionHeader_1 = require("player-common-controls/controls/SectionHeader");
Object.defineProperty(exports, "CommonControlsSectionHeader", { enumerable: true, get: function () { return SectionHeader_1.SectionHeader; } });
var Text_1 = require("player-common-controls/controls/Text");
Object.defineProperty(exports, "CommonControlsText", { enumerable: true, get: function () { return Text_1.Text; } });
var Panel_1 = require("player-layout-controls/controls/Panel");
Object.defineProperty(exports, "LayoutControlsPanel", { enumerable: true, get: function () { return Panel_1.Panel; } });
var player_rich_text_viewer_1 = require("player-rich-text-viewer");
exports.RichTextViewer = player_rich_text_viewer_1.default;
var UploadViewer_1 = require("../UploadViewer/UploadViewer");
Object.defineProperty(exports, "UploadViewer", { enumerable: true, get: function () { return UploadViewer_1.UploadViewer; } });
var Hyperlink_1 = require("player-common-controls/controls/Hyperlink");
Object.defineProperty(exports, "CommonControlsHyperlink", { enumerable: true, get: function () { return Hyperlink_1.Hyperlink; } });
var UploadErrorMessage_1 = require("../UploadErrorMessage/UploadErrorMessage");
Object.defineProperty(exports, "UploadErrorMessage", { enumerable: true, get: function () { return UploadErrorMessage_1.UploadErrorMessage; } });
var ApplicationWorkflowAdditionalAttachments = (function (_super) {
    __extends(ApplicationWorkflowAdditionalAttachments, _super);
    function ApplicationWorkflowAdditionalAttachments(props) {
        var _this = _super.call(this, props) || this;
        _this.packageName = 'player-application-workflow';
        _this._renderView = _this._renderView.bind(_this);
        _this.viewSL = ViewSL_1.viewSL.apply(_this);
        _this.viewSL.constructor && _this.viewSL.constructor.apply(_this, arguments);
        _this._trackers = {};
        if (typeof csod.context.tracking !== 'undefined') {
            var monikerCallback_1 = function (moniker, eventName) {
                var evt = document.createEvent("Event");
                evt.initEvent("player-" + moniker + "-" + eventName, true, false);
                window.dispatchEvent(evt);
            };
            for (var reporter in csod.context.tracking) {
                var _loop_1 = function (moniker) {
                    var events = csod.context.tracking[reporter][moniker];
                    var _loop_2 = function (i, l) {
                        var event_1 = events[i];
                        var monikerKey = moniker + '.' + event_1;
                        if (typeof this_1._trackers[monikerKey] === 'undefined')
                            this_1._trackers[monikerKey] = function () { monikerCallback_1(moniker, event_1); };
                    };
                    for (var i = 0, l = events.length; i < l; i++) {
                        _loop_2(i, l);
                    }
                };
                var this_1 = this;
                for (var moniker in csod.context.tracking[reporter]) {
                    _loop_1(moniker);
                }
            }
        }
        return _this;
    }
    ApplicationWorkflowAdditionalAttachments.prototype.componentDidMount = function () {
        this.viewSL.mounted && this.viewSL.mounted.apply(this, arguments);
    };
    ApplicationWorkflowAdditionalAttachments.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (this.viewSL.shouldUpdate)
            return this.viewSL.shouldUpdate.apply(this, arguments);
        else
            return true;
    };
    ApplicationWorkflowAdditionalAttachments.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.viewSL.didUpdate && this.viewSL.didUpdate.apply(this, arguments);
    };
    ApplicationWorkflowAdditionalAttachments.prototype.componentWillUnmount = function () {
        this.viewSL.unmount && this.viewSL.unmount.apply(this, arguments);
    };
    ApplicationWorkflowAdditionalAttachments.prototype._proxyTrackEvent = function (moniker, eventID, eventName) {
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var args = [];
        for (var i = 3; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        var monikerKey = moniker + '.' + eventID;
        var monikerCallback = this._trackers[monikerKey] || function () { };
        return this._processEvent(eventName, args, 4, monikerCallback);
    };
    ApplicationWorkflowAdditionalAttachments.prototype._proxyEvent = function (eventName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return this._processEvent(eventName, args, 2, function () { });
    };
    ApplicationWorkflowAdditionalAttachments.prototype._processEvent = function (eventName, args, repeaterArgIndex, callback) {
        args = pushAndShiftArgs(args, repeaterArgIndex);
        if (typeof this.viewSL.events[eventName] === 'function') {
            var self_1 = this;
            return function proxy() {
                var combinedArgs = [].slice.call(arguments).concat(args);
                self_1.viewSL.events[eventName].apply(self_1, combinedArgs);
                csod.lastEventDate = new Date();
                callback();
            };
        }
        else {
            return function noFunc() {
                if (eventName) {
                    csod.logger.warn(eventName + ' is not a valid function. Please check for typos.');
                    csod.lastEventDate = new Date();
                }
                callback();
            };
        }
    };
    ApplicationWorkflowAdditionalAttachments.prototype._renderView = function () {
        var _this = this;
        var PlayerVisible = csod.engine.controls.Player.Visible;
        var PlayerSwitch = csod.engine.controls.Player.Switch;
        var root_handler = function () {
            var attachment_handler = function () {
                var attachment_result = _this.props.attachments.map(function (attachment, attachment$index) {
                    var fileUpload_handler = function () {
                        var fileUpload_result = attachment.fileUploads.map(function (fileUpload, fileUpload$index) {
                            var keyPrefix = undefined;
                            return [
                                React.createElement(Panel_1.Panel, { key: fileUpload$index.toString() + 0, paddingBottom: "Large", children: [
                                        React.createElement(UploadViewer_1.UploadViewer, { key: fileUpload$index.toString() + 0, fileUploadId: fileUpload.id, fileUploadText: _this.props.uploadDocumentText, fileUploadError: attachment.errorMessage, fileUploadWidth: "Block", guid: fileUpload.token.value, sizeLimit: 15728640, fileViewerId: fileUpload.fileViewerId, fileUrl: fileUpload.token.fileUrl, fileName: fileUpload.token.title, fileSize: fileUpload.token.fileSize, showUpload: fileUpload.token.showUpload, fileIconName: fileUpload.token.fileIcon, accept: [".doc", ".docx", ".pdf", ".txt", ".bmp", ".gif", ".jpg", ".jpeg", ".png"], maxFileNameLength: 50, fileSizeErrorMessage: _this.props.fileSizeErrorMessage, fileDeleteMessage: _this.props.fileDeleteMessage, fileNameLengthErrorMessage: _this.props.fileNameLengthErrorMessage, fileTypeErrorMessage: _this.props.fileTypeErrorMessage, fileUploadIsEnabled: _this.props.fileUploadIsEnabled, onSuccess: _this._proxyEvent("onFileUploadSuccess", attachment, attachment$index, "repeaterArgs", fileUpload, fileUpload$index, "repeaterArgs"), onError: _this._proxyEvent("onFileUploadError", attachment, attachment$index, "repeaterArgs", fileUpload, fileUpload$index, "repeaterArgs"), onDelete: _this._proxyEvent("onFileDelete", attachment, attachment$index, "repeaterArgs", fileUpload, fileUpload$index, "repeaterArgs") })
                                    ] })
                            ];
                        });
                        return fileUpload_result;
                    };
                    var keyPrefix = undefined;
                    return [
                        React.createElement(GridCol_1.GridCol, { key: attachment$index.toString() + 0, children: [
                                React.createElement(SectionHeader_1.SectionHeader, { key: attachment$index.toString() + 0, size: "H2", text: attachment.title }),
                                React.createElement(PlayerVisible, { key: attachment$index.toString() + 1, visible: attachment.isRequired, children: [
                                        React.createElement(Text_1.Text, { key: attachment$index.toString() + 0, text: "*", color: "Error", size: "Large" })
                                    ] }),
                                React.createElement(Panel_1.Panel, { key: attachment$index.toString() + 2, paddingVertical: "Small", children: [
                                        React.createElement(player_rich_text_viewer_1.default, { key: attachment$index.toString() + 0, html: attachment.instructions, allowedTags: ["h1", "h2", "h3", "br", "a", "p", "ul", "li", "ol", "b", "i", "strong", "em", "strike", "table", "thead", "caption", "tbody", "tr", "th", "td", "img", "span"], allowedAttributes: _this.props.allowedAttributes })
                                    ] }),
                                fileUpload_handler(),
                                React.createElement(PlayerVisible, { key: attachment$index.toString() + 4, visible: attachment.allowMoreAttachments, children: [
                                        React.createElement(Hyperlink_1.Hyperlink, { key: attachment$index.toString() + 0, type: "Action", text: _this.props.addAdditionalAttachmentText, tag: "link-add-additional-attachments", onClick: _this._proxyEvent("onAdditionalAttachmentCreate", attachment, attachment$index, "repeaterArgs") }),
                                        React.createElement(UploadErrorMessage_1.UploadErrorMessage, { key: attachment$index.toString() + 1, errorMessage: attachment.errorMessage })
                                    ] })
                            ] })
                    ];
                });
                return attachment_result;
            };
            return [
                React.createElement(GridLayout_1.GridLayout, { key: 0, colsWidth: "12", gutterVertical: "Medium", children: [
                        attachment_handler()
                    ] })
            ];
        };
        return root_handler();
    };
    ApplicationWorkflowAdditionalAttachments.prototype.render = function () {
        return (React.createElement("div", { className: "p-viewSL-applicationworkflowadditionalattachments" }, this._renderView()));
    };
    ApplicationWorkflowAdditionalAttachments.defaultProps = {
        attachments: [], fileUploadWidth: '', fileSizeErrorMessage: '', fileDeleteMessage: '', fileNameLengthErrorMessage: '', fileTypeErrorMessage: '', allowedAttributes: undefined, uploadDocumentText: null, fileUploadIsEnabled: true, addAdditionalAttachmentText: 'Add Additional Attachment',
        onFileUploadSuccess: function () { }, onFileUploadError: function () { }, onFileDelete: function () { }, onAdditionalAttachmentCreate: function () { }
    };
    return ApplicationWorkflowAdditionalAttachments;
}(React.Component));
exports.ApplicationWorkflowAdditionalAttachments = ApplicationWorkflowAdditionalAttachments;
function pushAndShiftArgs(args, repeaterArgIndex) {
    if (args[repeaterArgIndex] === 'repeaterArgs') {
        args.push(args.shift());
        args.push(args.shift());
        args.shift();
        pushAndShiftArgs(args, repeaterArgIndex);
    }
    return args;
}
if (!window["__LOCALES__"])
    window["__LOCALES__"] = {};
window["__LOCALES__"]["ApplicationWorkflowAdditionalAttachments"] = [];



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationWorkflowAdditionalAttachments/ApplicationWorkflowAdditionalAttachments.js
// module id = 365
// module chunks = 0 2